import { computeStreak } from './streak';
import {
  chapterScores,
  lastActive,
  problemsSolved,
  recentProblems,
  totalMinutes,
} from './stats';

export interface ParentSummary {
  lastActive: number;
  streak: number;
  totalMinutes: number;
  problemsSolved: number;
  chapterScores: Record<string, number>;
  recentProblems: Array<{
    chapter: string | null;
    topic: string;
    input_type: string;
    hints_used: number;
    confidence: string | null;
    timestamp: number;
  }>;
}

export async function buildSummary(): Promise<ParentSummary> {
  const [streak, minutes, solved, scores, active, recent] = await Promise.all([
    computeStreak(),
    totalMinutes(),
    problemsSolved(),
    chapterScores(),
    lastActive(),
    recentProblems(10),
  ]);
  return {
    lastActive: active,
    streak,
    totalMinutes: minutes,
    problemsSolved: solved,
    chapterScores: scores,
    recentProblems: recent,
  };
}

// Shared token — baked in at build time via Vite env, matched server-side.
// Not a security boundary against someone inspecting the JS bundle, but stops
// anyone-on-the-internet from spamming /api/sync with fake data.
const SYNC_TOKEN = import.meta.env.VITE_SYNC_TOKEN as string | undefined;

export async function syncSummaryToParent(summary?: ParentSummary) {
  const payload = summary ?? (await buildSummary());
  try {
    await fetch('/api/sync', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Sync-Token': SYNC_TOKEN ?? '',
      },
      body: JSON.stringify({ summary: payload }),
    });
  } catch (err) {
    console.warn('sync skipped:', err);
  }
}
